module.exports = __webpack_public_path__ + "static/img/block_height_right.ee0da3a6.png";